module.exports = __webpack_public_path__ + "img/pic_333832_2.071e318f.jpg";